import { animate, state, style, transition, trigger } from '@angular/animations';

// Removing left as it is currently not well supported in the drawer component
export type DrawerPosition = 'right';

export type DrawerState = 'in' | 'out';

export type DrawerConfig = { animationTimeout?: number };

export const DEFAULT_DRAWER_WIDTH = 500;

export const DEFAULT_DRAWER_CONFIG: DrawerConfig = {
    animationTimeout: 350
};

export const MOBILE_DRAWER_CONFIG: DrawerConfig = {
    ...DEFAULT_DRAWER_CONFIG,
    animationTimeout: 100
};

export const DEFAULT_DRAWER_POSITION: DrawerPosition = 'right';

export const DEFAULT_DRAWER_STATE: DrawerState = 'out';

export const SLIDE_IN_OUT_TRIGGER = trigger('slideInOut', [
    state('in', style({ width: `${DEFAULT_DRAWER_WIDTH}px` })),
    state('out', style({ width: '0px' })),
    transition('in <=> out', animate('300ms ease-in-out'))
]);

export const DISPLAY_IN_OUT_DRAWER_TRIGGER = trigger('displayInOut', [
    state('in', style({ display: 'flex' })),
    state('out', style({ display: 'none' })),
    transition('in <=> out', animate('0ms ease-in-out'))
]);
